module.exports = __webpack_public_path__ + "static/media/webdesign-services-img2.83a8c198.jpg";